export const ptBR = {
  // Hero Section
  hero: {
    jobTitle: "Engenheiro de Software & Engenheiro de Computação",
    name: "Renan Ferreira",
    subtitle: "Engenheiro de software full-stack",
    contactButton: "Entre em Contato",
    linkedinButton: "LinkedIn"
  },

  // Navigation
  nav: {
    about: "Sobre",
    experience: "Experiência",
    skills: "Habilidades",
    education: "Educação",
    contact: "Contato"
  },

  // About Section
  about: {
    title: "Sobre Mim",
    description:
      "Engenheiro de Computação formado pela Universidade Federal de Santa Catarina e fundador do Remi, um aplicativo de fitness e bem-estar social que eu projeto, construo e entrego de ponta a ponta — do produto em React Native ao backend em Node.js por trás dele. Em paralelo ao Remi, atuo como engenheiro de software fullstack construindo sistemas frontend e backend escaláveis e confiáveis, com contribuições que aprimoraram desempenho, segurança e experiência do usuário em vários produtos. Apaixonado por aprendizado contínuo, expando ativamente meu conjunto de habilidades com novas linguagens, tecnologias e padrões arquitetônicos",
    expertiseTitle: "Áreas de Especialização",
    location: "Curitiba, Paraná, Brasil",
    email: "renanferreira.engineer@gmail.com",
    software: "Software",
    facts: {
      title: "Resumo",
      currently: "Atualmente",
      founder: "Fundador",
      education: "Formação",
      basedIn: "Localização",
      email: "Email"
    },
    remi: {
      badge: "Fundador",
      name: "Remi",
      tagline: "App de fitness e bem-estar social",
      description:
        "Um aplicativo mobile multiplataforma para registrar treinos e atividades com GPS, competir em desafios gamificados e conectar-se com uma comunidade de entusiastas de fitness — projetado, construído e entregue de ponta a ponta.",
      stack: ["React Native", "Expo", "Node.js", "PostgreSQL"],
      cta: "Ver o projeto",
      website: "remifitness.com"
    },
  },

  // Experience Section
  experience: {
    visitSite: "Visitar site",
    professionalTitle: "Experiência Profissional",
    founderTitle: "Fundador",
    researchTitle: "Experiência em Pesquisa",
    rise: {
      company: "Rise",
      role: "Engenheiro de Software",
      period: "Presente",
      location: "New York, NY",
      description:
        "Rise é uma plataforma que simplifica a folha de pagamento global para equipes modernas, permitindo pagamentos simplificados para contratados e funcionários em tempo integral em todo o mundo. Engenheiro de software full-stack desenvolvendo soluções escaláveis para processamento de folha de pagamento internacional e conformidade.",
      highlights: []
    },
    voyager: {
      company: "Voyager",
      role: "Engenheiro de Software",
      period: "Nov 2022 - Dez 2024",
      location: "Houston, TX",
      description:
        "Voyager é uma solução de logística marítima. Trabalho na equipe de sobreestadia, desenvolvendo soluções para automatizar cálculos de demurrage. Engenheiro de software full-stack trabalhando com Vue.js, Node.js, Python, MySQL, Gitlab e serviços AWS.",
      highlights: [
        "Liderou o desenvolvimento de um sistema interpretando eventos de navios a partir de Statements of Facts (SOF) para cálculos automáticos de demurrage",
        "Liderou o desenvolvimento de uma ferramenta para análise de cálculos de demurrage e colaboração chamada negotiation cockpit",
        "Construiu a primeira versão de uma plataforma low-code para registro de contratos marítimos",
        "Contribuiu com correções de bugs e desenvolveu componentes de UI reutilizáveis em vários projetos"
      ]
    },
    medprev: {
      company: "MedPrev",
      role: "Engenheiro de Software",
      period: "Fev 2022 - Nov 2022",
      location: "Curitiba, PR",
      description:
        "Parte da equipe que facilita o agendamento de consultas e exames médicos. Engenheiro de software full-stack trabalhando com Vue.js, Node.js, Python, PostgreSQL e serviços Azure.",
      highlights: [
        "Liderou o desenvolvimento de um sistema de compra assistida para exames/consultas",
        "Construiu a primeira versão de um sistema de avaliação de experiência do usuário",
        "Manteve componentes do sistema principal de agendamento"
      ]
    },
    cargon: {
      company: "Cargon",
      role: "Engenheiro de Software",
      period: "Mar 2020 - Fev 2022",
      location: "Curitiba, PR",
      description:
        "Trabalhou no sistema de emissão de documentos para motoristas de entrega. Engenheiro de software full-stack usando Node.js, React.js, MicrosoftSQLServer e serviços Azure.",
      highlights: [
        "Contribuiu para a primeira versão do sistema de emissão, responsável por componentes principais",
        "Liderou o desenvolvimento do sistema complementar de emissão de CTE"
      ]
    },
    remi: {
      company: "Remi",
      url: "https://remifitness.com",
      role: "Fundador & Engenheiro Full-stack",
      period: "Presente",
      location: "Curitiba, PR",
      description:
        "Remi é um aplicativo mobile de fitness e bem-estar social que ajuda usuários a rastrear treinos, criar rotinas de treinamento, competir em desafios fitness e conectar-se com outros entusiastas de fitness.",
      highlights: [
        "Construiu um aplicativo mobile multiplataforma com React Native e Expo, com backend Node.js/Express e banco de dados PostgreSQL",
        "Desenvolveu rastreamento GPS em tempo real para corridas, pedaladas e caminhadas com visualização interativa em mapa",
        "Implementou funcionalidades sociais incluindo feed, mensagens em tempo real, comunidades e desafios em equipe",
        "Integrou gamificação com treinos baseados em missões, conquistas e sistema de progressão por XP",
        "Configurou sistema de assinatura e e-commerce"
      ]
    },
    automation: {
      company: "Laboratório de Automação e Robótica Móvel",
      role: "Pesquisador",
      period: "Abr 2018 – Dez 2018",
      location: "UFSC",
      description:
        "Usou microprocessador ESP8266 e RFID para automatizar o registro de presença."
    },
    quantumTeam: {
      company: "Equipe Quantum",
      role: "Programador de Microprocessadores",
      period: "Jul 2018 – Abr 2020",
      location: "UFSC",
      description:
        "Programou robôs usando Arduino e ESP8266 para competições regionais/nacionais."
    },
    plusEnergy: {
      company: "Plus Energy",
      role: "Desenvolvedor de Sistema Web",
      period: "Jul 2019 – Abr 2020",
      location: "UFSC",
      description:
        "Desenvolveu sistema de comunicação entre torre eólica e centro de controle, incluindo interface web para análise de dados."
    }
  },

  // Skills Section
  skills: {
    title: "Habilidades",
    hardSkills: "Habilidades Técnicas",
    softSkills: "Habilidades Interpessoais",
    projectTools: "Ferramentas & Gestão de Projetos"
  },

  // Education Section
  education: {
    title: "Educação",
    degree: "Engenharia de Computação",
    university: "Universidade Federal de Santa Catarina",
    period: "2018-2022",
    location: "Araranguá, SC",
    highlights: "Destaques do Programa",
    description:
      "Currículo abrangente cobrindo aspectos de hardware e software da engenharia de computação, com foco em aplicações práticas e tecnologias de ponta.",
    coursework: "Disciplinas Relevantes:",
    courses: [
      "Arquitetura de Computadores",
      "Algoritmos e Estruturas de Dados",
      "Sistemas Embarcados",
      "Sistemas de Banco de Dados",
      "Desenvolvimento Web",
      "Tecnologias IoT",
      "Processamento Digital de Sinais",
      "Sistemas Operacionais"
    ],
    researchProjects: "Projetos de Pesquisa",
    projects: [
      "Sistema automatizado de registro de presença usando tecnologia RFID",
      "Sistemas de monitoramento ambiental baseados em IoT"
    ]
  },

  // Contact Section
  contact: {
    title: "Entre em Contato",
    description:
      "Estou sempre aberto a discutir novos projetos, ideias criativas ou oportunidades de fazer parte da sua visão. Vamos nos conectar!",
    email: "Email",
    linkedin: "LinkedIn",
    location: "Localização",
    connect: "Conecte-se comigo",
    github: "GitHub"
  },

  // Footer
  footer: {
    jobTitle: "Engenheiro de Software",
    copyright: "Todos os direitos reservados."
  },

  // Language Switcher
  langSwitcher: {
    switchTo: "Switch to English"
  }
};
